import { getLocalKlimVar, mapAppTypeToString, useAppType, useGetFarmerType } from "utils";

import { SignupUserParams } from "models";

export type SignupAttribution = Omit<SignupUserParams, "email" | "signal" | "terms" | "businessUseConfirmed" | "germanJurisdictionAccepted">;

// we keep attribution consistent for all signup sources. Only `signupOrigin` may vary by entry point.
export const useSignupAttribution = (signupOrigin?: string): SignupAttribution => {
  const appType = useAppType();
  const farmerType = useGetFarmerType();

  return {
    referrer: getLocalKlimVar("partner") ?? getLocalKlimVar("referrer") ?? undefined,
    appType: mapAppTypeToString(appType),
    utm_source: getLocalKlimVar("utm_source"), // eslint-disable-line camelcase
    utm_campaign: getLocalKlimVar("utm_campaign"),
    utm_medium: getLocalKlimVar("utm_medium"),
    farmerType,
    signupOrigin,
  };
};
